export class MediaSlice {
    constructor(public startPosition: number, public endPosition: number, public src: string) {}
}
